/** Certifications static UI routes (Management + Management2). */

export const CERTIFICATIONS_LIST_PATH = '/vms/certifications';
export const MANAGEMENT2_CERTIFICATIONS_LIST_PATH = '/vms/management2/certifications-licenses';

export function certificationsDetailPath(
  registerRowId: string | number,
  useManagement2Route = false,
): string {
  const id = encodeURIComponent(String(registerRowId));
  return useManagement2Route
    ? `${MANAGEMENT2_CERTIFICATIONS_LIST_PATH}/${id}`
    : `${CERTIFICATIONS_LIST_PATH}/${id}`;
}

/** @deprecated Use certificationsDetailPath(id, true) */
export function management2CertificationsDetailPath(registerRowId: string | number): string {
  return certificationsDetailPath(registerRowId, true);
}

export function certificationsListPathFromLocation(pathname: string): string {
  return pathname.includes('/management2/certifications-licenses')
    ? MANAGEMENT2_CERTIFICATIONS_LIST_PATH
    : CERTIFICATIONS_LIST_PATH;
}

export function isManagement2CertificationsPath(pathname: string): boolean {
  return (
    pathname === MANAGEMENT2_CERTIFICATIONS_LIST_PATH ||
    pathname.startsWith(`${MANAGEMENT2_CERTIFICATIONS_LIST_PATH}/`)
  );
}

export function isCertificationsStaticPath(pathname: string): boolean {
  return (
    pathname === CERTIFICATIONS_LIST_PATH ||
    pathname === '/vms/certifications/legacy' ||
    /^\/vms\/certifications\/[^/]+$/.test(pathname) ||
    isManagement2CertificationsPath(pathname)
  );
}
